// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-content-quote {
    flex-grow: 1;
}

.quote-search-filters {
    border: 1px solid #ddd;
    padding: 20px;
    background-color: #f8f9fa;
    border-radius: 5px;
}

.search-button-quote {
    display: block;
    width: 343px;
    padding: 15px;
    background-color: #222;
    color: white;
    font-size: 18px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    margin: 30px auto;
}

.quote-list-container {
    margin-top: 30px;
}

.quote-list-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
}

.quote-list-header span {
    font-size: 16px;
    font-weight: bold;
}

.btn-pdf-download {
    background-color: white;
    border: 1px solid #ccc;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
}

.quote-table {
    width: 100%;
    border-collapse: collapse;
    border-top: 2px solid #333;
    cursor: pointer;
}

.quote-table th,
.quote-table td {
    text-align: center;
    padding: 15px 10px;
    border-bottom: 1px solid #ddd;
}

.quote-table th {
    font-weight: bold;
    background-color: #f8f9fa;
}

.product-cell {
    display: flex;
    align-items: center;
    gap: 15px;
    text-align: left;
}

.product-cell img {
    max-width: 60px;
    height: auto;
}

.quote-list-actions {
    margin-top: 20px;
    display: flex;
    gap: 10px;
}

/* 견적 상품 정보 레이아웃 */
.quotation-product-info {
    display: flex;
    align-items: center;
    gap: 15px;
    padding: 10px;
    background-color: #f8f9fa;
    border-radius: 6px;
    border: 1px solid #dee2e6;
}

.quotation-product-image {
    flex-shrink: 0;
}

.quotation-product-details {
    flex: 1 1;
    min-width: 0; /* 텍스트 넘침 방지 */
}

.quotation-product-details p {
    margin: 0 0 4px 0;
    line-height: 1.3;
    font-size: 13px;
}

.quotation-product-details p:last-child {
    margin-bottom: 0;
}

.quotation-product-details p strong {
    font-weight: 600;
    color: #333;
    font-size: 14px;
}

.quotation-product-details p:not(:first-child) {
    color: #666;
    font-size: 12px;
}

/* 주문 제작 표시 스타일 */
.custom-order-display {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px;
    background-color: #f8f9fa;
    border-radius: 6px;
    border: 1px solid #dee2e6;
}

.custom-order-icon {
    font-size: 24px;
    flex-shrink: 0;
}

.custom-order-text {
    flex: 1 1;
}

.custom-order-text p {
    margin: 0;
    line-height: 1.3;
}

.custom-order-text p:first-child {
    font-weight: 600;
    color: #333;
    font-size: 14px;
}

.custom-order-text p:last-child {
    color: #666;
    font-size: 12px;
}

/* Tablet and smaller devices */
@media (max-width: 1024px) {
    .search-button-quote {
        width: 100%;
    }
}

/* Mobile devices */
@media (max-width: 768px) {
    .quote-table thead {
        display: none;
    }

    .quote-table, .quote-table tbody, .quote-table tr, .quote-table td {
        display: block;
        width: 100%;
    }

    .quote-table tr {
        margin-bottom: 15px;
        border: 1px solid #ddd;
        border-radius: 5px;
        overflow: hidden;
    }

    .quote-table td {
        text-align: right;
        padding-left: 50%;
        position: relative;
    }

    .quote-table td::before {
        content: attr(data-label);
        position: absolute;
        left: 15px;
        width: calc(50% - 30px);
        padding-right: 10px;
        white-space: nowrap;
        text-align: left;
        font-weight: bold;
    }
    
    .product-cell {
        flex-direction: column;
        align-items: flex-start;
    }

    /* 반응형 대응 */
    .custom-order-display {
        padding: 8px;
        gap: 8px;
    }
    
    .custom-order-icon {
        font-size: 20px;
    }
    
    .custom-order-text p:first-child {
        font-size: 13px;
    }
    
    .custom-order-text p:last-child {
        font-size: 11px;
    }
} `, "",{"version":3,"sources":["webpack://./src/admin/css/QuotationManagementPage.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;;IAEI,kBAAkB;IAClB,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,SAAS;AACb;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,YAAY,EAAE,cAAc;AAChC;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA,+BAA+B;AAC/B;IACI;QACI,WAAW;IACf;AACJ;;AAEA,mBAAmB;AACnB;IACI;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,mBAAmB;QACnB,sBAAsB;QACtB,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;QACzB,kBAAkB;QAClB,UAAU;QACV,uBAAuB;QACvB,mBAAmB;QACnB,mBAAmB;QACnB,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA,WAAW;IACX;QACI,YAAY;QACZ,QAAQ;IACZ;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".admin-content-quote {\n    flex-grow: 1;\n}\n\n.quote-search-filters {\n    border: 1px solid #ddd;\n    padding: 20px;\n    background-color: #f8f9fa;\n    border-radius: 5px;\n}\n\n.search-button-quote {\n    display: block;\n    width: 343px;\n    padding: 15px;\n    background-color: #222;\n    color: white;\n    font-size: 18px;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    margin: 30px auto;\n}\n\n.quote-list-container {\n    margin-top: 30px;\n}\n\n.quote-list-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 15px;\n}\n\n.quote-list-header span {\n    font-size: 16px;\n    font-weight: bold;\n}\n\n.btn-pdf-download {\n    background-color: white;\n    border: 1px solid #ccc;\n    padding: 10px 20px;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 14px;\n}\n\n.quote-table {\n    width: 100%;\n    border-collapse: collapse;\n    border-top: 2px solid #333;\n    cursor: pointer;\n}\n\n.quote-table th,\n.quote-table td {\n    text-align: center;\n    padding: 15px 10px;\n    border-bottom: 1px solid #ddd;\n}\n\n.quote-table th {\n    font-weight: bold;\n    background-color: #f8f9fa;\n}\n\n.product-cell {\n    display: flex;\n    align-items: center;\n    gap: 15px;\n    text-align: left;\n}\n\n.product-cell img {\n    max-width: 60px;\n    height: auto;\n}\n\n.quote-list-actions {\n    margin-top: 20px;\n    display: flex;\n    gap: 10px;\n}\n\n/* 견적 상품 정보 레이아웃 */\n.quotation-product-info {\n    display: flex;\n    align-items: center;\n    gap: 15px;\n    padding: 10px;\n    background-color: #f8f9fa;\n    border-radius: 6px;\n    border: 1px solid #dee2e6;\n}\n\n.quotation-product-image {\n    flex-shrink: 0;\n}\n\n.quotation-product-details {\n    flex: 1;\n    min-width: 0; /* 텍스트 넘침 방지 */\n}\n\n.quotation-product-details p {\n    margin: 0 0 4px 0;\n    line-height: 1.3;\n    font-size: 13px;\n}\n\n.quotation-product-details p:last-child {\n    margin-bottom: 0;\n}\n\n.quotation-product-details p strong {\n    font-weight: 600;\n    color: #333;\n    font-size: 14px;\n}\n\n.quotation-product-details p:not(:first-child) {\n    color: #666;\n    font-size: 12px;\n}\n\n/* 주문 제작 표시 스타일 */\n.custom-order-display {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 10px;\n    background-color: #f8f9fa;\n    border-radius: 6px;\n    border: 1px solid #dee2e6;\n}\n\n.custom-order-icon {\n    font-size: 24px;\n    flex-shrink: 0;\n}\n\n.custom-order-text {\n    flex: 1;\n}\n\n.custom-order-text p {\n    margin: 0;\n    line-height: 1.3;\n}\n\n.custom-order-text p:first-child {\n    font-weight: 600;\n    color: #333;\n    font-size: 14px;\n}\n\n.custom-order-text p:last-child {\n    color: #666;\n    font-size: 12px;\n}\n\n/* Tablet and smaller devices */\n@media (max-width: 1024px) {\n    .search-button-quote {\n        width: 100%;\n    }\n}\n\n/* Mobile devices */\n@media (max-width: 768px) {\n    .quote-table thead {\n        display: none;\n    }\n\n    .quote-table, .quote-table tbody, .quote-table tr, .quote-table td {\n        display: block;\n        width: 100%;\n    }\n\n    .quote-table tr {\n        margin-bottom: 15px;\n        border: 1px solid #ddd;\n        border-radius: 5px;\n        overflow: hidden;\n    }\n\n    .quote-table td {\n        text-align: right;\n        padding-left: 50%;\n        position: relative;\n    }\n\n    .quote-table td::before {\n        content: attr(data-label);\n        position: absolute;\n        left: 15px;\n        width: calc(50% - 30px);\n        padding-right: 10px;\n        white-space: nowrap;\n        text-align: left;\n        font-weight: bold;\n    }\n    \n    .product-cell {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    /* 반응형 대응 */\n    .custom-order-display {\n        padding: 8px;\n        gap: 8px;\n    }\n    \n    .custom-order-icon {\n        font-size: 20px;\n    }\n    \n    .custom-order-text p:first-child {\n        font-size: 13px;\n    }\n    \n    .custom-order-text p:last-child {\n        font-size: 11px;\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
